import { cancelCampaign } from 'actions/campaigns'
import { alert } from 'actions/flash'
import useDispatch from 'hooks/useDispatch'
import React from 'react'
import { Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { LinkContainer } from 'react-router-bootstrap'
import { useShowV3 } from 'scenes/CampaignCenter/Builder/hooks'
import { selectCampaignTypeByType__deprecated } from 'selectors/campaignType'
import { useAbility } from 'utilities/ability'
import { reportLink, ReportLink as ReportLinkT } from 'utilities/campaignUtils'

import { Fields as Campaign } from 'models/Campaign'
import { ReducedCampaign } from 'models/UserCampaign'

type Props = {
  campaign: Campaign | ReducedCampaign
  canManageType?: boolean
}

const ReportLink: React.FC<Props> = ({ campaign, canManageType = true }) => {
  const dispatch = useDispatch()
  const ability = useAbility()
  const showV3 = useShowV3(campaign.type)

  const campaignType = useSelector(state =>
    //@ts-ignore
    selectCampaignTypeByType__deprecated(state.orm, campaign.type)
  )

  async function clickCancelButton() {
    const action = await dispatch(cancelCampaign(campaign.id))
    if (action.error) {
      dispatch(
        alert({
          key: 'danger',
          message: I18n.t(`thanx_campaigns.landing.reporting.cancel_error`),
          error: action.error.message ? action.error.message : null,
        })
      )
    }
  }

  const alternateButton =
    campaign.state !== 'scheduled' || !canManageType ? null : (
      <Button bsStyle="link" onClick={clickCancelButton}>
        {I18n.t(`thanx_campaigns.landing.reporting.cancel_button`)}
      </Button>
    )

  let linkInfo: ReportLinkT | null = !!campaignType
    ? reportLink(campaign, campaignType, showV3)
    : null
  let textSource = linkInfo?.state
  if (ability.cannot('review', 'Campaign') && textSource === 'in_review') {
    textSource = 'draft'
  }
  // Show "View" instead of "Edit" when user lacks manage permission for this type
  if (
    !canManageType &&
    (textSource === 'draft' || textSource === 'in_review')
  ) {
    textSource = 'upcoming' // renders as "View"
  }
  const text = I18n.t(
    `thanx_campaigns.landing.reporting.table.cta.${textSource}`
  )
  if (linkInfo?.state === 'unavailable') return null
  if (linkInfo?.type === 'linkcontainer') {
    return (
      <>
        {alternateButton}
        <LinkContainer to={linkInfo.href}>
          <Button bsStyle="link">{text}</Button>
        </LinkContainer>
      </>
    )
  }

  return (
    <>
      {alternateButton}
      <Button bsStyle="link" href={linkInfo?.href}>
        {text}
      </Button>
    </>
  )
}

export default ReportLink
